import { useState, useEffect, useRef } from "react";
import {
  PlayArrowRounded,
  PauseRounded,
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
  VolumeOffRounded,
  VolumeUpRounded,
} from "@mui/icons-material";


import React from "react";
import videojs from "video.js";
import videojsPlaylistPlugin from "videojs-playlist";
import "video.js/dist/video-js.css";

videojs.registerPlugin("playlist", videojsPlaylistPlugin);

export const Story = ({ data}) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const [progress, setProgress] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  const [playlist, setPlaylist] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState();

  const initPlayer = async () => {
    let player;
    if (!playerRef.current) {
      const videoElement = videoRef.current;

      if (!videoElement) return;

      player = playerRef.current = videojs(
        videoElement,
        {
          autoplay: true,
          controls: false,
          muted: true,
          responsive: true,
          fluid: true,
        },
        () => {
          videojs.log("player is ready");
        }
      );

      player.on("play", () => {
        console.log(`playing index ${player.playlist.currentIndex()}`);
        setPlaying(true);
        setCurrentIndex(player.playlist.currentIndex());
        setCurrentItem(player.playlist()[player.playlist.currentIndex()]);
        setProgress(0);
      });

      player.on("pause", () => {
        setPlaying(false);
      });

      player.on("timeupdate", (e) => {
        setProgress(
          (playerRef.current.currentTime() / playerRef.current.duration()) * 100
        );
      });
    } else {
      console.log("Using existing player");
      player = playerRef.current;
    }

    player.playlist(playlist);
    player.playlist.autoadvance(0);
  };

  useEffect(() => {
    initPlayer();
  }, [playlist]);

  useEffect(() => {
    setPlaylist(
      data.content.map((item) => {
        return {
          sources: [
            {
              src: item.src,
            },
          ],
          poster: item.thumbnail,
        };
      })
    );
  }, [videoRef]);

  const playNext = () => {
    if (playerRef.current.playlist.currentIndex() < playlist.length - 1) {
      playerRef.current.playlist.next();
    }
  };

  const playPrevious = () => {
    if (playerRef.current.playlist.currentIndex() === 0) {
      playerRef.current.currentTime(0);
    } else {
      if (progress < 50) {
        playerRef.current.playlist.previous();
      } else {
        playerRef.current.currentTime(0);
        playerRef.current.play();
      }
    }
  };

  const playIndex = (index) =>{
    playerRef.current.playlist.currentItem(index);
  }

  const play = () => {
    playerRef.current.play();
  };

  const pause = () => {
    playerRef.current.pause();
  };

  const mute = () => {
    playerRef.current.muted(true);
    setMuted(true);
  };

  const unmute = () => {
    playerRef.current.muted(false);
    setMuted(false);
  };
  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
      <div id={`widget-${data.id}`} className="relative w-full h-full bg-black bg-cover bg-center"
        style={{
          backgroundImage: `url(${currentItem ? currentItem.poster : ""})`,
        }}
      >
        <div className="h-full w-full overflow-hidden flex flex-col justify-center backdrop-blur-xl bg-black/70">
          <div data-vjs-player className="h-full">
            <video ref={videoRef} playsInline={true} className="video-js vjs-big-play-centered" />
          </div>
        </div>
        <div className="absolute top-0 left-0 w-full h-full flex z-10">
          <div className="flex items-center justify-start px-3 text-white/50 w-1/3 h-full bg-gradient-to-r from-black/30 to-transparent opacity-0 md:hover:opacity-100 transition-opacity cursor-pointer" onClick={playPrevious}>
            <ArrowBackIosRounded fontSize="large" />
          </div>
          <div className="flex items-center justify-end px-3 text-white/50 w-2/3 h-full bg-gradient-to-l from-black/30 to-transparent opacity-0 md:hover:opacity-100 transition-opacity cursor-pointer" onClick={playNext}>
            <ArrowForwardIosRounded fontSize="large" />
          </div>
        </div>
        <div className="flex flex-col absolute px-1 md:px-4 lg:px-6 pb-2 top-0 left-0 w-full bg-gradient-to-b from-black/50 to-transparent z-20">
          <div className="flex items-center">
            {playlist.map((item, index) => (
              <div
                key={index}
                className="px-1 py-3 flex flex-col cursor-pointer group"
                style={{ width: `${100 / playlist.length}%` }}
                onClick={()=>{playIndex(index)}}
              >
                <div className="h-[2px] w-full bg-white/30 group-hover:bg-white/50">
                  {index < currentIndex && (
                    <div className="h-full w-full bg-white transition-all"></div>
                  )}
                  {index === currentIndex && (
                    <div
                      className="h-full w-0 bg-white transition-all"
                      style={{ width: `${progress}%` }}
                    ></div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-end">
            {(playing && (
              <PauseRounded
                onClick={pause}
                fontSize="large"
                className="text-white/70 hover:text-whtie cursor-pointer"
              />
            )) || (
              <PlayArrowRounded
                onClick={play}
                fontSize="large"
                className="text-white/70 hover:text-whtie cursor-pointer"
              />
            )}

            {(muted && (
              <VolumeOffRounded
                onClick={unmute}
                fontSize="large"
                className="text-white/70 hover:text-whtie cursor-pointer"
              />
            )) || (
              <VolumeUpRounded
                onClick={mute}
                fontSize="large"
                className="text-white/70 hover:text-whtie cursor-pointer"
              />
            )}
          </div>
        </div>
      </div>
  );
};

export default Story;
